

var defaultI18n = {
  prev: 'Prev',
  next: 'Next'
};

export { defaultI18n };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/pagination/dist/esm/internal/props.js
// module id = 844
// module chunks = 0